export default __webpack_public_path__ + "static/media/profile.e378ca50.png";